import { render, staticRenderFns } from "./AutoSuggest.vue?vue&type=template&id=18362f94"
import script from "./AutoSuggest.vue?vue&type=script&lang=js"
export * from "./AutoSuggest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports